import React from 'react'
import styles from './index.module.less'

interface LoginTips {
  visible?: boolean
  children?: any
}

export default function Index({ visible, children }: LoginTips) {
  return visible ? (
    <div className={styles.box}>
      <div className={styles.cont}>{children}</div>
    </div>
  ) : (
    <></>
  )
}
